module.exports = __webpack_public_path__ + "static/img/brand.e42c3fdc.jpg";